import { lazy, type LazyExoticComponent } from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon/types';

// Map of icon names to their dynamic import.
export const skillIcon = {
	skill: (): Promise<typeof import('@atlaskit/icon-lab/core/skill')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon" */ '@atlaskit/icon-lab/core/skill'
		),
	assets: (): Promise<typeof import('@atlaskit/icon/core/assets')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-assets" */ '@atlaskit/icon/core/assets'
		),
	add: (): Promise<typeof import('@atlaskit/icon/core/add')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-add" */ '@atlaskit/icon/core/add'
		),
	'chart-bar-line': (): Promise<typeof import('@atlaskit/icon-lab/core/chart-bar-line')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-chart-bar-line" */ '@atlaskit/icon-lab/core/chart-bar-line'
		),
	'ai-generative-text': (): Promise<typeof import('@atlaskit/icon-lab/core/ai-generative-text')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-ai-generative-text" */ '@atlaskit/icon-lab/core/ai-generative-text'
		),
	'work-item': (): Promise<typeof import('@atlaskit/icon/core/work-item')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-work-item" */ '@atlaskit/icon/core/work-item'
		),
	'lock-locked': (): Promise<typeof import('@atlaskit/icon/core/lock-locked')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-lock-locked" */ '@atlaskit/icon/core/lock-locked'
		),
	'chart-pie': (): Promise<typeof import('@atlaskit/icon/core/chart-pie')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-chart-pie" */ '@atlaskit/icon/core/chart-pie'
		),
	plan: (): Promise<typeof import('@atlaskit/icon-lab/core/plan')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-plan" */ '@atlaskit/icon-lab/core/plan'
		),
	settings: (): Promise<typeof import('@atlaskit/icon/core/settings')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-settings" */ '@atlaskit/icon/core/settings'
		),
	'project-status': (): Promise<typeof import('@atlaskit/icon/core/project-status')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-project-status" */ '@atlaskit/icon/core/project-status'
		),
	'merge-success': (): Promise<typeof import('@atlaskit/icon/core/merge-success')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-merge-success" */ '@atlaskit/icon/core/merge-success'
		),
	'person-add': (): Promise<typeof import('@atlaskit/icon/core/person-add')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-person-add" */ '@atlaskit/icon/core/person-add'
		),
	'people-group': (): Promise<typeof import('@atlaskit/icon/core/people-group')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-people-group" */ '@atlaskit/icon/core/people-group'
		),
	'person-added': (): Promise<typeof import('@atlaskit/icon/core/person-added')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-person-added" */ '@atlaskit/icon/core/person-added'
		),
	login: (): Promise<typeof import('@atlaskit/icon/core/log-in')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-login" */ '@atlaskit/icon/core/log-in'
		),
	'ai-generative-text-summary': (): Promise<
		typeof import('@atlaskit/icon/core/ai-generative-text-summary')
	> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-summary" */ '@atlaskit/icon/core/ai-generative-text-summary'
		),
	transition: (): Promise<typeof import('@atlaskit/icon/core/transition')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-dependency" */ '@atlaskit/icon/core/transition'
		),
	board: (): Promise<typeof import('@atlaskit/icon/core/board')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-board" */ '@atlaskit/icon/core/board'
		),
	release: (): Promise<typeof import('@atlaskit/icon/core/release')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-release" */ '@atlaskit/icon/core/release'
		),
	'app-switcher': (): Promise<typeof import('@atlaskit/icon/core/app-switcher')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-app-switcher" */ '@atlaskit/icon/core/app-switcher'
		),
	search: (): Promise<typeof import('@atlaskit/icon/core/search')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-search" */ '@atlaskit/icon/core/search'
		),
	'playlist-add': (): Promise<typeof import('@atlaskit/icon-lab/core/playlist-add')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-playlist-add" */ '@atlaskit/icon-lab/core/playlist-add'
		),
	'playlist-remove': (): Promise<typeof import('@atlaskit/icon-lab/core/playlist-remove')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-playlist-remove" */ '@atlaskit/icon-lab/core/playlist-remove'
		),
	summary: (): Promise<typeof import('@atlaskit/icon/core/ai-generative-text-summary')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-summary" */ '@atlaskit/icon/core/ai-generative-text-summary'
		),
	clock: (): Promise<typeof import('@atlaskit/icon/core/clock')> =>
		import(
			/* webpackChunkName: "@atlassian/rovo-platform-ui-components/rovo-skill-icon-clock" */ '@atlaskit/icon/core/clock'
		),
	'ai-generative-chapters': (): Promise<
		typeof import('@atlaskit/icon-lab/core/ai-generative-chapters')
	> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-ai-generative-chapters" */ '@atlaskit/icon-lab/core/ai-generative-chapters'
		),
	talent: (): Promise<typeof import('@atlaskit/icon-lab/core/talent')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-talent" */ '@atlaskit/icon-lab/core/talent'
		),
	incident: (): Promise<typeof import('@atlaskit/icon/core/incident')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-incident" */ '@atlaskit/icon/core/incident'
		),
	form: (): Promise<typeof import('@atlaskit/icon/core/form')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-form" */ '@atlaskit/icon/core/form'
		),
	ticket: (): Promise<typeof import('@atlaskit/icon-lab/core/ticket')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-ticket" */ '@atlaskit/icon-lab/core/ticket'
		),
	alert: (): Promise<typeof import('@atlaskit/icon/core/alert')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-alert" */ '@atlaskit/icon/core/alert'
		),
	pulse: (): Promise<typeof import('@atlaskit/icon/core/pulse')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-pulse" */ '@atlaskit/icon/core/pulse'
		),
	'text-lengthen': (): Promise<typeof import('@atlaskit/icon-lab/core/text-lengthen')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-text-lengthen" */ '@atlaskit/icon-lab/core/text-lengthen'
		),
	'ai-generative-cleanup': (): Promise<
		typeof import('@atlaskit/icon-lab/core/ai-generative-cleanup')
	> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-ai-generative-cleanup" */ '@atlaskit/icon-lab/core/ai-generative-cleanup'
		),
	survey: (): Promise<typeof import('@atlaskit/icon-lab/core/survey')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-survey" */ '@atlaskit/icon-lab/core/survey'
		),
	'text-review': (): Promise<typeof import('@atlaskit/icon-lab/core/text-review')> =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-skill-icon-text-review" */ '@atlaskit/icon-lab/core/text-review'
		),
} as const;

/**
 * @deprecated import from @atlassian/rovo-platform-types instead
 * @private
 */
export type SkillColor =
	| 'LIME'
	| 'RED'
	| 'ORANGE'
	| 'YELLOW'
	| 'GREEN'
	| 'TEAL'
	| 'BLUE'
	| 'PURPLE'
	| 'MAGENTA'
	| 'GRAY'
	| 'DEFAULT';
export type SkillIconName = keyof typeof skillIcon;

export const defaultIcon: () => Promise<typeof import('@atlaskit/icon-lab/core/skill')> =
	skillIcon.skill;

type SkillIconMap = {
	[K in SkillIconName]: React.LazyExoticComponent<
		Awaited<ReturnType<(typeof skillIcon)[K]>>['default']
	>;
};

export type SkillIconComponent = (typeof skillIconMap)[SkillIconName];

export const skillIconMap = Object.fromEntries(
	Object.entries(skillIcon).map(([key, loader]) => [key, lazy(loader)]),
) as SkillIconMap;

export const DefaultSkillIcon: LazyExoticComponent<{
	(props: NewCoreIconProps): JSX.Element;
	displayName: string;
}> = skillIconMap.skill;
